// extracted by mini-css-extract-plugin
export default {"container":"Signup_container__qKRcg","innerBox":"Signup_innerBox__RFegH","heading":"Signup_heading__btLRh","footer":"Signup_footer__VtJG2","error":"Signup_error__47FGz"};